import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X, Phone, Star } from "lucide-react";
import CalendlyButton from "./CalendlyButton";

const KEY = "rae_welcome_popup_shown";

export default function WelcomePopup() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(KEY)) return;
    const t = setTimeout(() => {
      sessionStorage.setItem(KEY, "1");
      setOpen(true);
    }, 5000);
    return () => clearTimeout(t);
  }, []);

  if (!open) return null;

  const close = () => setOpen(false);

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-6"
      data-testid="welcome-popup-overlay"
      onClick={close}
    >
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" />
      <div
        className="relative w-full max-w-[440px] bg-[#0b0b0b] border border-[#d4af37]/40 p-10 sm:p-12 animate-[popIn_0.4s_ease-out]"
        onClick={(e) => e.stopPropagation()}
        data-testid="welcome-popup"
      >
        <button
          type="button"
          onClick={close}
          aria-label="Close"
          className="absolute top-4 right-4 text-white/50 hover:text-[#d4af37] transition"
          data-testid="welcome-popup-close"
        >
          <X size={20} strokeWidth={1.5} />
        </button>

        <div className="kicker mb-6">Let's Build</div>
        <h3 className="h-display text-white text-[38px] sm:text-[44px] leading-[1.0]">
          YOUR NEXT<br />CAMPAIGN<span className="text-[#d4af37]">.</span>
        </h3>
        <Link
          to="/contact"
          onClick={close}
          className="kicker text-[#d4af37] hover:text-[#f2c66d] inline-block mt-6"
          data-testid="welcome-popup-contact-link"
        >
          Or send us a message →
        </Link>
        <div className="mt-8">
          <CalendlyButton testId="welcome-popup-calendly">Book a Strategy Call</CalendlyButton>
        </div>
        <div className="mt-8 space-y-4">
          <a href="tel:2533318487" className="flex items-center gap-2 text-[#d4af37] tracking-widest text-[12px]" data-testid="welcome-popup-phone">
            <Phone size={14} strokeWidth={1.4} /> 253-331-8487
          </a>
          <a
            href="https://g.page/r/Cf1jEdpNJ_I1EBM/review"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-white/70 hover:text-[#d4af37] tracking-widest text-[12px] transition"
            data-testid="welcome-popup-review"
          >
            <Star size={14} strokeWidth={1.4} className="text-[#d4af37]" /> Leave Us A Google Review
          </a>
        </div>
      </div>
    </div>
  );
}
